import { Button, FormField, FormRow } from '../common'
import styles from './PostComposer.module.css'

export default function PromotionSettings({
  postType,
  expiresAt,
  scheduledFor,
  promoPriority,
  interleaveEvery,
  placementMode,
  onChange,
}) {
  // Expiry applies to both post types; only promotion placement resets.
  const selectOrganic = () => {
    onChange('postType', 'organic')
    onChange('scheduledFor', '')
    onChange('promoPriority', 0)
    onChange('interleaveEvery', '')
    onChange('placementMode', 'pinned')
  }

  return (
    <div className={styles.advancedGroup}>
      <h4 className={styles.advancedGroupTitle}>Post type</h4>
      <div className={styles.postTypeToggle}>
        <button
          type="button"
          className={`${styles.postTypeBtn} ${postType === 'organic' ? styles.postTypeBtnActive : ''}`}
          onClick={selectOrganic}
        >
          Organic
        </button>
        <button
          type="button"
          className={`${styles.postTypeBtn} ${postType === 'promotion' ? styles.postTypeBtnActive : ''}`}
          onClick={() => onChange('postType', 'promotion')}
        >
          Promotion
        </button>
      </div>

      {postType === 'organic' ? (
        <div className={styles.organicExpiry}>
          <FormField
            label="Expires At"
            type="datetime-local"
            value={expiresAt}
            onChange={(event) => onChange('expiresAt', event.target.value)}
            help="Optional. The post leaves the feed at this time."
            labelExtra={expiresAt ? (
              <Button type="button" variant="ghost" size="compact" aria-label="Clear expiry" onClick={() => onChange('expiresAt', '')}>
                Clear
              </Button>
            ) : null}
          />
        </div>
      ) : null}

      {postType === 'promotion' ? (
        <div className={styles.promotionSettings}>
          <FormRow>
            <FormField
              label="Expires At"
              type="datetime-local"
              value={expiresAt}
              onChange={(event) => onChange('expiresAt', event.target.value)}
              required
            />
            <FormField
              label="Scheduled Go-Live"
              type="datetime-local"
              value={scheduledFor}
              onChange={(event) => onChange('scheduledFor', event.target.value)}
            />
          </FormRow>

          <FormField label="Placement">
            <div className={styles.placementGroup}>
              <label className={styles.placementOption}>
                <input
                  type="radio"
                  name="placement"
                  value="pinned"
                  checked={placementMode === 'pinned'}
                  onChange={() => {
                    onChange('placementMode', 'pinned')
                    onChange('interleaveEvery', '')
                  }}
                />
                Pin to Top
              </label>
              <label className={styles.placementOption}>
                <input
                  type="radio"
                  name="placement"
                  value="interleave"
                  checked={placementMode === 'interleave'}
                  onChange={() => onChange('placementMode', 'interleave')}
                />
                Interleave in Feed
              </label>
            </div>
          </FormField>

          {placementMode === 'interleave' ? (
            <FormField
              label="Every N posts"
              type="number"
              value={interleaveEvery}
              onChange={(event) => onChange('interleaveEvery', event.target.value)}
              min={1}
              placeholder="e.g., 5"
            />
          ) : null}

          <FormField
            label="Priority"
            type="number"
            value={promoPriority}
            onChange={(event) => onChange('promoPriority', parseInt(event.target.value, 10) || 0)}
          />
        </div>
      ) : null}
    </div>
  )
}
